
import { Vue, Component } from 'vue-property-decorator'
import { can } from '@/globalFunctions'
import ls from '@/ls'
import FinancialReportShowDetailsTab from '@/views/financial/tabs/FinancialReportShowDetailsTab.vue'

@Component({
  methods: { can },
  components: { FinancialReportShowDetailsTab }
})

export default class FinancialReportShow extends Vue {
  currentTab:string = ls.get('financialReportShowActiveTab') || 'invoicing'

  setActiveTab (tab:string) : void {
    ls.set('financialReportShowActiveTab', tab)
    this.currentTab = tab
  }
}
